import { usePermissionGuard } from "../../../../hooks/usePermissionGuard";

const NO_PERMISSION_REASON = "You don't have permission for this action.";

/**
 * The four Study Path scopes the pre-redesign screens gated on (`StudyPath.js`,
 * `TableStudyPath.js`, `CreateStudyPath.js`). Returned as plain booleans so callers can fold them
 * into the same `disabled`/`disabledReason` props they already use for the version lock — matching
 * legacy, which rendered each control disabled rather than hiding it.
 * `usePermissionGuard` returns null until permissions load, which counts as not granted.
 */
export default function useStudyPathPermissions() {
    const canAdd = usePermissionGuard({ scopes: ["pmcstudypathadd"] });
    const canEdit = usePermissionGuard({ scopes: ["pmcstudypathedit"] });
    const canDelete = usePermissionGuard({ scopes: ["pmcstudypathdelete"] });
    const canEditModules = usePermissionGuard({ scopes: ["pmcstudypathmoduleedit"] });

    return {
        canAdd: canAdd === true,
        canEdit: canEdit === true,
        canDelete: canDelete === true,
        canEditModules: canEditModules === true,
        noPermissionReason: NO_PERMISSION_REASON,
    };
}
